<template>
  <div class="setInfo_content content">
    <a href="javascript:;">
      <img class="logo" src="/static/logo.png" />
    </a>
    <div class="form-warp">
      <div class="title">{{ title }}</div>
      <el-form ref="form" :rules="rules" :model="form">
        <h4>{{ sub_title }}</h4>
        <div class="label" v-if="step === 'nickname'">
          <div class="upcontent">
            <cropImg
              ref="cropComponent"
              dialog-width="500"
              dialog-height="500"
              :crop-width="180"
              :crop-height="180"
              min-width="180"
              min-height="180"
              :showtext="showText"
              @update-img="updateImage"
              :is-upload="avatar == '' || isUpload"
            ></cropImg>
            <div
              style="width: 100%; height: 118px; text-align: center"
              class="endcroping"
              v-show="avatar != ''"
              @click="reUpload"
            >
              <img
                :src="
                  avatar | imageUrl('/static/profile_img_default.png', 180, 180)
                "
              />
            </div>
            <span class="change" @click="reUpload" v-show="avatar === ''">{{
              $t("global.上传头像")
            }}</span>
          </div>
        </div>
        <el-form-item
          prop="nickname"
          class="nickname"
          v-if="step === 'nickname' || step === 'changeNickname'"
        >
          <el-input
            type="text"
            v-model="form.nickname"
            :placeholder="$t('global.设置昵称')"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="password"
          class="phoneCode"
          v-if="step === 'setNewPassword'"
        >
          <el-input
            type="password"
            v-model="form.password"
            :placeholder="$t('global.设置新密码')"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="password"
          class="phoneCode"
          v-if="step === 'password'"
        >
          <el-input
            type="password"
            v-model="form.password"
            :placeholder="$t('global.设置新密码')"
          ></el-input>
        </el-form-item>
        <el-button
          type="primary"
          native-type="submit"
          @click.prevent="login"
          class="btn-login"
          v-if="step === 'nickname'"
          >{{ $t("global.完成注册") }}</el-button
        >
        <el-button
          type="primary"
          native-type="submit"
          @click.prevent="login"
          class="btn-login"
          v-if="step === 'changeNickname'"
          >{{ $t("global.提交") }}</el-button
        >
        <el-button
          type="primary"
          native-type="submit"
          @click.prevent="setNewPassword"
          class="btn-login"
          v-if="step === 'setNewPassword'"
          >{{ $t("global.提交") }}</el-button
        >
        <el-button
          type="primary"
          native-type="submit"
          @click.prevent="setPassword"
          class="btn-login"
          v-if="step === 'password'"
          >{{ $t("global.提交") }}</el-button
        >
        <div class="login-text" v-if="step === 'setNewPassword'">
          <router-link class="reg-link" to="/login">{{
            $t("global.直接登录")
          }}</router-link>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import cropImg from "@/components/CropImg.vue";
import * as qiniu from "qiniu-js";
export default {
  name: "login",
  metaInfo() {
    return {
      title: this.$t("global.设置资料") + " | MANA",
    };
  },
  data() {
    return {
      title: this.$t("global.完善资料"),
      sub_title: this.$t("global.设置资料"),
      rules: {
        nickname: [
          {
            required: true,
            message: this.$t("global.请输入昵称"),
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[\u4E00-\u9FA5A-Za-z0-9_]+$/;
              if (!reg.test(value)) {
                callback(
                  new Error(this.$t("global.昵称不能有表情符号等特殊字符"))
                );
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("global.密码不能为空"),
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (!/\S{7,}/.test(value) && !/^\d+$/.test(value)) {
                callback(
                  new Error(this.$t("global.密码不少于7位，且不能为纯数字"))
                );
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
      },
      form: {
        nickname: "",
        password: "",
      },
      showText: true,
      avatar: "",
      isUpload: false,
      step: null,
      userId: null,
      phone: null,
      areaCode: null,
      isLogin: false,
    };
  },
  components: {
    cropImg,
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.step = this.$route.params.step;
      this.userId = this.$route.query.userId;
      this.phone = this.$route.query.phone;
      this.isLogin = this.$route.query.login;
      this.areaCode = "+" + this.$route.query.areaCode;
      if (this.$store.state.peopleMessage.avatar) {
        this.avatar = this.$store.state.peopleMessage.avatar;
      }
      if (
        this.$store.state.peopleMessage.nickName ||
        this.$store.state.peopleMessage.nickname
      ) {
        this.form.nickname =
          this.$store.state.peopleMessage.nickName ||
          this.$store.state.peopleMessage.nickname;
      }
      if (this.step === "setNewPassword") {
        this.sub_title = this.$t("global.设置新密码");
        this.title = this.$t("global.找回密码");
      } else if (this.step === "changeNickname") {
        this.sub_title = this.$t("global.修改昵称");
        this.title = this.$t("global.修改昵称");
      }
    },
    reUpload() {
      this.$refs.cropComponent.reUpload("3size");
    },
    updateImage(img) {
      let $this = this;
      this.imgUrl = img.data;
      let imgFile = this.$jsonUtils.base64ToFile(this.imgUrl, "a.png");
      var observable;
      var subscription;
      var error = function (err) {
        $this.uploadMessage = $this.$t("global.上传失败");
      };
      var complete = function (res) {
        // $this.uploadMessage = $this.$t("global.上传成功");
        $this.avatar = res.key;
        let url = `/api/u/changeAvatar`;
        let params = {
          avatar: $this.avatar,
        };
        if ($this.isLogin) {
          url = `/api/passport/changeUserAvatar`;
          params.userId = $this.userId;
        }
        $this.$http.post(url, params).then((res) => {
          if (res.code === "OK") {
            $this.$message({
              message: $this.$t("global.头像更新成功"),
              type: "success",
            });
          } else {
            $this.avatar = "";
          }
        });
      };

      var next = function (response) {};

      var subObject = {
        next: next,
        error: error,
        complete: complete,
      };

      var config = {
        useCdnDomain: true,
        region: null,
        domain: "https://image.manamana.net",
        forceDirect: true,
      };
      var putExtra = {
        fname: imgFile.name,
        params: {},
        mimeType: null,
      };
      this.$http.get("/api/common/upload/image/token").then((res) => {
        observable = qiniu.upload(
          imgFile,
          Date.parse(new Date()) + "_" + this.$jsonUtils.randomLetter(8),
          res.message,
          putExtra,
          config
        );
        subscription = observable.subscribe(subObject);
      });
      // let param = new FormData();
      // param.append("files", imgFile);
      // param.append("fileNames", "avatar");
      // // param.append("deleteNames", this.avatar);
      // this.$http
      //   .post("/api/common/upload/images", param, {
      //     headers: {
      //       "Content-Type": "multipart/form-data",
      //     },
      //   })
      //   .then((response) => {
      //     if (response.code === "OK") {
      //       this.avatar = response.data.avatar.key;
      //       let url = `/api/u/changeAvatar`;
      //       let params = {
      //         avatar: this.avatar,
      //       };
      //       if (this.isLogin) {
      //         url = `/api/passport/changeUserAvatar`;
      //         params.userId = this.userId;
      //       }
      //       this.$http.post(url, params).then((res) => {
      //         if (res.code === "OK") {
      //           this.$message({
      //             message: this.$t("global.头像更新成功"),
      //             type: "success",
      //           });
      //         } else {
      //           this.avatar = "";
      //         }
      //       });
      //     } else {
      //       this.$message({
      //         message: response.message,
      //         type: "error",
      //       });
      //     }
      //   });
    },
    login() {
      if (this.form.nickname) {
        let url = `/api/mobile/u/changeNickname`;
        if (this.isLogin) {
          url = `/api/passport/changeNicknameLogin`;
        }
        const params = {
          userId: this.userId,
          nickname: this.form.nickname,
        };
        this.$http.post(url, params).then((res) => {
          if (res.code === "OK") {
            localStorage.setItem("auth_token", res.data.token);
            this.$http.get("/api/customer/info/get").then((response) => {
              this.$store.dispatch("setNewState", {
                peopleMessage: response.data,
                isLogin: true,
              });
              localStorage.setItem("isLogin", "true");
              if (window.history.length > 1 && this.returnUrl) {
                this.$router.back(-1);
              } else if (this.returnUrl) {
                window.location.href = this.returnUrl;
              } else if (
                localStorage.getItem("redirecturl") &&
                localStorage.getItem("redirecturl") != ""
              ) {
                window.location.href = localStorage.getItem("redirecturl");
              } else {
                this.$router.push("/");
              }
            });
          }
        });
      } else {
        this.$message(this.$t("global.请填写昵称"));
      }
    },
    setPassword() {
      const url = `/api/passport/phone_login`;
      const params = {
        regSource: "PC",
        password: this.form.password,
        phone: this.phone,
        areaCode: this.areaCode,
      };
      this.$http.post(url, params).then((res) => {
        if (res.code === "OK") {
          this.$message({
            message: `${this.$t("global.注册成功")},${this.$t(
              "global.请完善个人信息"
            )}`,
            type: "success",
          });
          // this.$router.push(`/setInfo/nickname?userId=${res.data.userId}`);
          this.step = "nickname";
          localStorage.setItem("auth_token", res.data.token);
          localStorage.setItem("userId", res.data.userId);
        }
      });
    },
    setNewPassword() {
      const url = ``;
    },
  },
};
</script>

<style lang="stylus">
.setInfo_content.content {
  width: 100%;
  height: 100%;
  background: url('/static/login/login-back.jpg') no-repeat center center;
  background-size: cover;
  position: relative;
  box-sizing: border-box;

  &:before {
    content: '';
    position: absolute;
    display: block;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.4);
  }

  .logo {
    position: absolute;
    left: 1.8rem;
    top: 0.3rem;
    display: inline-block;
    width: 1.3rem;
    height: 0.34rem;
  }

  .form-warp {
    width: 330px;
    padding: 0 40px 40px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    height: 500px;

    .title {
      padding: 20px 0;
      color: #fff;
      text-align: center;
      font-size: 32px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
    }

    .el-form {
      background: rgba(0, 0, 0, 0.4);
      padding: 40px;
      border-radius: 10px;

      h4 {
        color: #fff;
        font-size: 24px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        text-align: center;
        padding-bottom: 40px;
        position: relative;

        &::before {
          content: '';
          display: inline-block;
          width: 100px;
          height: 2px;
          background: #fff;
          position: absolute;
          bottom: 30px;
          left: 76px;
        }
      }

      .upcontent {
        padding-bottom: 10px;
      }

      .change {
        color: #fff;
        position: relative;
        cursor: pointer;
        left: 77px;
        top: -60px;
        display: inline-block;
        width: 95px;
        height: 30px;
        text-align: center;
        background: rgba(0, 0, 0, 0.3);
        padding-top: 4px;
      }

      .showtop {
        display: none;
      }

      .endcroping {
        img {
          width: 100px;
          height: 100px;
          border-radius: 50px;
        }
      }

      .uploaddiv {
        height: 140px;
      }
    }

    .btn-login {
      width: 100%;
    }

    button.el-button--primary {
      background: #3664ED;
      border: none;
    }

    .login-text {
      padding-top: 20px;

      a {
        color: #5F86FC;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/passport/SetInfo.vue